<template>
  <div class="pa-10">
    <v-card :color="color" dark elevation="24">
      <v-card-title>
        <caption
          class="font-weight-light title pt-2"
          aria-label="tabla de periodos"
        >
          <p>Periodos</p>
        </caption>
        <template>
          <v-btn
            :color="icon_color"
            small
            fab
            dark
            class="ml-2"
            @click="newItem"
            aria-label="Crear periodo"
          >
            <v-tooltip bottom :color="tooltip_color">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-plus</v-icon>
              </template>
              <span>Crear periodo</span>
            </v-tooltip>
          </v-btn>
          <PeriodsForm
            :item="editedItem"
            v-model="dialog"
            :index="editedIndex"
          />
        </template>

        <div class="flex-grow-1"></div>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar periodo"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :style="{ 'background-color': color }"
        dark
        :search="search"
        :headers="headers"
        :items="periods"
        :items-per-page="5"
        :footer-props="{
          'items-per-page-all-text': 'Todos',
          'items-per-page-text': 'Registros por página',
          'items-per-page-options': [5, 10, -1],
          'show-current-page': true,
          pagination: {},
        }"
        no-results-text="No se encuentran resultados"
        no-data-text="No hay datos ingresados"
      >
        <template v-slot:item.year="{ item }">
          <p>{{ item.year }} - {{ item.period }}</p>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom :color="tooltip_color">
            <template v-slot:activator="{ on }">
              <v-icon
                small
                :color="icon_color"
                v-on="on"
                class="mr-2"
                @click="editItem(item)"
                >mdi-pencil-outline</v-icon
              >
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip
            bottom
            :color="tooltip_color"
            v-if="itHasInterventionPlan(item.id) == false"
          >
            <template v-slot:activator="{ on }">
              <v-icon
                small
                :color="icon_color"
                v-on="on"
                @click="deleteItem(item, register, item.name)"
                >mdi-delete</v-icon
              >
            </template>
            <span>Eliminar</span>
          </v-tooltip>

          <v-tooltip bottom :color="tooltip_color" v-else>
            <template v-slot:activator="{ on }">
              <v-icon
                small
                :color="icon_color"
                v-on="on"
                @click="cantErraseMessage(item)"
                >mdi-delete</v-icon
              >
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import deleteMixin from '../../mixins/deletemixin'
import PeriodsForm from '../../components/manager/PeriodsForm'

export default {
  mixins: [deleteMixin],
  components: {
    PeriodsForm,
  },
  created() {
    this.$store.commit('layout/SET_LAYOUT', 'organization-layout')
    this.$store.dispatch('period/fetchPeriods', this.$route.params.id)
    this.$store.dispatch(
      'interventionplan/fetchInterventionPlans',
      this.$route.params.id
    )
  },
  computed: {
    ...mapState({
      color: (state) => state.layout.color,
      link: (state) => state.layout.link,
      icon_color: (state) => state.layout.icon_color,
      tooltip_color: (state) => state.layout.tooltip_color,
      periods: (state) => state.period.periods,
      interventionplans: (state) => state.interventionplan.intervention_plans,
    }),
  },
  data() {
    return {
      search: '',
      dialog: false,
      headers: [
        {
          text: 'NOMBRE',
          align: 'left',
          value: 'name',
        },
        {
          text: 'Periodo',
          align: 'center',
          value: 'year',
        },
        {},

        {
          text: 'ACCIONES',
          value: 'action',
          sortable: false,
          width: '100px',
          align: 'center',
        },
      ],
      register: 'period/deletePeriod',
      editedIndex: -1,
      defaultItem: {
        id: null,
        organization_id: null,
        name: '',
        year: '',
        period: '',
      },
      editedItem: {
        id: null,
        organization_id: null,
        name: '',
        year: '',
        period: '',
      },
    }
  },

  methods: {
    editItem(item) {
      this.editedIndex = this.periods.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    newItem() {
      this.$validator.reset()
      this.editedIndex = -1
      this.editedItem = Object.assign({}, this.defaultItem)
      this.dialog = true
    },
    remove(item) {
      this.num = 0
      this.deleteItem(item, this.register, item.name, this.num)
    },
    cantErraseMessage(item) {
      this.$swal({
        html:
          `<span style="color: #FBC02D; font-family: Helvetica">El periodo ${item.name}</span>` +
          `<br>` +
          `<br>` +
          `<span style="color: white; font-family: Helvetica">No se puede eliminar, existen planes de intervención asociados<span>`,
        type: 'warning',
        animation: false,
        background: '#0B5683',
        width: '350px',
        confirmButtonColor: '#FBC02D',
        showConfirmButton: true,
        confirmButtonText:
          "<span style='font-family: Helvetica'>Aceptar</span>",
      })
    },
    itHasInterventionPlan(id) {
      var is_id_there = false
      for (var i = 0; i < this.interventionplans.length; i++) {
        if (this.interventionplans[i].period_id === id) {
          is_id_there = true
          break
        }
      }
      return is_id_there
    },
  },
}
</script>

<style scoped>
</style>